import React, { useState } from 'react'

import { Banner, Box, Button, FeatureBadge, Text } from '@driftt/dds'
import { faBullhorn } from '@driftt/dds.icons/light/faBullhorn'

import { SalesRepsFeedbackModal } from './SalesRepsFeedbackModal'

interface FeedbackModalProps {
  setShowBanner: React.Dispatch<React.SetStateAction<boolean>>
}

const SalesRepsFeedbackBanner = ({ setShowBanner }: FeedbackModalProps) => {
  const [showFeebackModal, setShowFeedbackModal] = useState(false)

  return (
    <>
      <Box>
        <Banner.Root variant="beta" onClose={() => setShowBanner(false)}>
          <Banner.Content>
            <FeatureBadge variant="beta" />
            <Text as="span">Welcome to the new Sales Rep setup report!</Text>
          </Banner.Content>
          <Banner.Actions>
            <Button
              variant="tertiary"
              onClick={() => setShowFeedbackModal(true)}
            >
              <Button.Icon icon={faBullhorn} />
              Give feedback
            </Button>
          </Banner.Actions>
        </Banner.Root>
      </Box>
      {showFeebackModal && (
        <SalesRepsFeedbackModal
          open={showFeebackModal}
          onClose={() => setShowFeedbackModal(false)}
          onDismiss={() => setShowBanner(false)}
        />
      )}
    </>
  )
}

export default SalesRepsFeedbackBanner
